import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tabs-container"
}
const _hoisted_2 = { class: "custom-tabs" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryHeader',
  props: {
  initialContext: {
    type: Object,
    required: true,
  },
  isTranscriptionStart: {
    type: Boolean,
    default: false,
  },
  summaryStatus: {
    type: String,
    required: true,
  },
},
  emits: ["tabChanged"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeTab = ref("summary");

const handleTabClick = (tab: string) => {
  activeTab.value = tab;
  emit("tabChanged", tab);
};

return (_ctx: any,_cache: any) => {
  return (!__props.isTranscriptionStart && __props.summaryStatus === 'ready')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab-item", { active: activeTab.value === 'summary' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTabClick('summary')))
          }, " Resumo ", 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})